import React, { useContext, useState } from 'react';

import { UserContext } from 'contexts/userContext';
import { getTradePlan } from 'data/getTradePlan';
import { TradePlan } from 'models/tradePlan';

import { TradesContext } from '../contexts/tradesContext';
import { getTrades } from '../data/getTrades';
import { Trade } from '../models/trades';

export const TradesContextProvider = ({ children }) => {
	const [trades, setTrades] = useState(null as Trade[]);
	const [tradePlans, setTradePlans] = useState(null as TradePlan[]);
	const [alreadyCalled, setAlreadyCalled] = useState(false);
	const { user } = useContext(UserContext);

	if (!alreadyCalled) {
		setAlreadyCalled(true);
		getTrades(user).then((tradesData) => {
			setTrades(tradesData);
		});
		getTradePlan(user).then((tradePlansData) => {
			setTradePlans(tradePlansData);
		});
	}

	function saveTrades(newTrades: Trade[]): void {
		setTrades(newTrades);
	}

	function saveTradePlans(newTradePlans: TradePlan[]): void {
		setTradePlans(newTradePlans);
	}

	return (
		<TradesContext.Provider
			value={{ trades, tradePlans, saveTrades, saveTradePlans }}
		>
			{children}
		</TradesContext.Provider>
	);
};
